import { gql } from '@apollo/client';

export const QUERY_SOFT_SKILLS = gql`
  query QuerySoftSkills {
    getUserSoftSkills {
      note {
        qteca
        qtepro
        qtepro
        qtequiz
        qterebond
        qtevente
      }
      unpayedOrders
      commandes
      classe {
        commandes
        unpayedOrders
        users {
          role {
            id
            name
          }
          commandes {
            status
          }
        }
        noteclasse {
          cavente
          qteca
          qtepro
          qterebond
          venterebond
          moyennegenerale
          pro
          quiz
          qtequiz
          nbvente
          qtevente
        }
      }
    }
    getClassePosition {
      rank
      totalClasses
    }
    getUnpayedCo {
      classe
      eleve
    }
  }
`;
